import React from 'react';
import { Button, Input, Modal } from 'antd';
import { TPayerCandidate } from 'types/insuranceEligibility';
import { ROUTE_MODAL_COPY } from '../copy';
import s from '../s.module.less';

type Props = {
    open: boolean;
    picked?: TPayerCandidate;
    carrierOnFile?: string;
    draft: string;
    sending: boolean;
    onSend: (text: string) => void;
    onClose: () => void;
};

// 选定候选 payer 后的患者确认：通知患者是这个动作的一部分——不能让账单成为患者第一次
// 听说换了计费计划的方式，所以发送即流程结束。但选错 payer 得有退路，因此留了关闭按钮：
// 关掉等于没选，不记「已通知」，卡片退回候选列表。
// 遮罩点击仍不关闭，避免手滑点空白丢掉已经写好的消息草稿。
const RouteConfirmModal: React.FC<Props> = ({ open, picked, carrierOnFile, draft, sending, onSend, onClose }) => {
    const [text, setText] = React.useState('');

    React.useEffect(() => {
        if (open) setText(draft);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    if (!picked) return null;

    return (
        <Modal
            open={open}
            title={ROUTE_MODAL_COPY.title}
            onCancel={onClose}
            maskClosable={false}
            width={480}
            wrapClassName={s.eligModalScope}
            footer={
                <Button type="primary" loading={sending} onClick={() => onSend(text)}>
                    {ROUTE_MODAL_COPY.send}
                </Button>
            }
        >
            <div className={s.routeBody}>{ROUTE_MODAL_COPY.body(picked.name, carrierOnFile)}</div>
            <div className={s.cardReqLabel}>{ROUTE_MODAL_COPY.msgLabel}</div>
            <Input.TextArea rows={8} value={text} onChange={(e) => setText(e.target.value)} />
        </Modal>
    );
};

export default RouteConfirmModal;
